import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics.service/analytics.service';


declare let ga: Function;
@Component({
  selector: 'app-aboutme',
  templateUrl: './aboutme.component.html',
  styleUrls: ['./aboutme.component.less']
})
export class AboutmeComponent {
  wave_hand:string
  constructor(analyticsService:AnalyticsService) {
    this.wave_hand="&#128075;&#127997;"
    analyticsService.eventEmitter("read_about_me","AboutMe","Load","PageAboutMe")
   }
}
